import styled from 'styled-components';

import {
    Card,
    IconChevronRightCircle,
    token,
    spaceMixin,
    Paragraph,
} from '@zillow/constellation';

import {
    Tag,
} from '@zillow/zrs-comet';

export const StyledCard = styled(Card)`
    min-height: 150px;
    cursor: pointer;
`;

export const StyledIconChevronRightCircle = styled(IconChevronRightCircle)`
    color: ${token('colors.brand')};
    float: right;
    position: relative;
    bottom: 4px;
`;

export const StyledSubTextContainer = styled.div`
    margin-bottom: ${spaceMixin('sm')};
    margin-top: ${spaceMixin('xs')};
`;

export const StyledTag = styled(Tag)`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const StyledParagraphForNameDisplay = styled(Paragraph)`
    text-transform: capitalize;
`;
